module.exports = __webpack_public_path__ + "img/lalanitaaviso_2v_1.6f7c899a.webp";